export default __webpack_public_path__ + "static/media/Facebook.1c1ea3ae.svg";